export default function BusSideSVG({ className }) {
    return (
        <svg
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M15 5H4a3 3 0 0 0-3 3v10a1 1 0 0 0 1 1h2.17a3 3 0 0 0 5.66 0h3.34a3 3 0 0 0 5.66 0H21a1 1 0 0 0 .96-.72l.08-.28a255.85 255.85 0 0 0 .72-2.54l.01-.02.01-.04c.1-.37.22-.88.22-1.4 0-.52-.13-1.03-.22-1.4l-.01-.04v-.03l-.17-.59a1 1 0 0 0-.12-.41l-1.12-4v-.02A3.58 3.58 0 0 0 18 5h-3Zm3.83 12h1.42l.08-.27.5-1.78c.1-.42.17-.7.17-.95s-.06-.53-.17-.94l-.01-.06H3v4h1.17a3 3 0 0 1 5.66 0h3.34a3 3 0 0 1 5.66 0ZM15 18a1 1 0 1 1 2 0 1 1 0 0 1-2 0Zm-8-1a1 1 0 1 1 0 2 1 1 0 0 1 0-2Zm0-6H3V8a1 1 0 0 1 1-1h3v4Zm2 0V7h5v4H9Zm7 0V7h2c.63 0 1.26.49 1.44 1.08l.82 2.92H16Z"
                fill="#000"
            />
        </svg>
    );
}
